import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { SupportService } from 'src/app/support.service';
import { MovingMoneyDoc } from 'src/typings';
import { MovingMoneyService } from '../moving-money.service';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateComponent {
  id: number | undefined;

  doc: MovingMoneyDoc | undefined;

  dialogRef: MatDialogRef<UpdateComponent> | undefined;

  private subscription: Subscription;

  constructor(
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private movingMoneyDocService: MovingMoneyService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    public supportService: SupportService,
    private notificationService: NotificationService
  ) {
    this.subscription = activateRoute.params.subscribe((params) => {
      this.id = params.id;
      if (this.id) {
        this.movingMoneyDocService.getOne(params.id).subscribe((doc) => {
          this.doc = doc;
          this.loadDoc();
        });
      }
    });
    this.bankFromFormControl.valueChanges.subscribe((bank) => {
      this.valueFormControl.setValue(0);
      this.restFormControl.setValue(bank.balance);
    });
  }

  createForm: UntypedFormGroup = this.fb.group({
    value: new UntypedFormControl(),
    rest: new UntypedFormControl(),
    bank_from: new UntypedFormControl(),
    bank_to: new UntypedFormControl(),
    commission: new UntypedFormControl(),
    date: new UntypedFormControl(new Date())
  });

  get date() {
    return this.createForm.controls.date.value;
  }

  get dateFormControl(): UntypedFormControl {
    return this.createForm.controls.date as UntypedFormControl;
  }

  get bank_from() {
    return this.createForm.controls.bank_from.value;
  }

  get bankFromFormControl(): UntypedFormControl {
    return this.createForm.controls.bank_from as UntypedFormControl;
  }

  get bank_to() {
    return this.createForm.controls.bank_to.value;
  }

  get bankToFormControl(): UntypedFormControl {
    return this.createForm.controls.bank_to as UntypedFormControl;
  }

  get commission() {
    return this.createForm.controls.commission.value;
  }

  get commissionFormControl(): UntypedFormControl {
    return this.createForm.controls.commission as UntypedFormControl;
  }

  get value() {
    return this.createForm.controls.value.value;
  }

  get valueFormControl(): UntypedFormControl {
    return this.createForm.controls.value as UntypedFormControl;
  }

  get rest() {
    return this.createForm.controls.rest.value;
  }

  get restFormControl(): UntypedFormControl {
    return this.createForm.controls.rest as UntypedFormControl;
  }

  get provider() {
    return this.createForm.controls.provider.value;
  }

  get providerFormControl(): UntypedFormControl {
    return this.createForm.controls.provider as UntypedFormControl;
  }

  loadDoc() {
    if (!this.doc) return this.notificationService.warning('Не могу найти документ!');
    if (this.doc.date) this.dateFormControl.setValue(this.doc.date);
    if (this.doc.bank_from) this.bankFromFormControl.setValue(this.doc.bank_from);
    if (this.doc.bank_to) this.bankToFormControl.setValue(this.doc.bank_to);
    if (this.doc.value) this.valueFormControl.setValue(this.doc.value);
    if (this.doc.commission) this.commissionFormControl.setValue(this.doc.commission);
  }

  restInput(event: any) {
    const value = event.target.value;
    if (this.bank_from) {
      this.valueFormControl.setValue(this.bank_from.balance - value - this.commission);
    }
  }

  valueInput(event: any) {
    const value = event.target.value;
    if (this.bank_from) {
      this.restFormControl.setValue(this.bank_from.balance - value - this.commission);
    }
  }

  commissionInput(event: any) {
    const value = event.target.value;
    if (this.bank_from) {
      this.restFormControl.setValue(this.rest - value);
    }
  }

  save() {
    if (this.doc) {
      this.movingMoneyDocService
        .save({
          id: this.doc.id,
          bank_from_id: this.bank_from.id,
          bank_to_id: this.bank_to.id,
          value: this.value,
          date: this.date,
          passed: this.doc.passed,
          commission: this.commission
        })
        .subscribe(
          () => {
            if (!this.dialogRef) {
              this.router.navigateByUrl('/docs/moving_money/list');
            } else {
              this.dialogRef.close();
            }
            this.notificationService.notice(`Документ №${this.id} сохранен!`);
          },
          (err) => {
            this.notificationService.warning(err.error.message);
          }
        );
    } else {
      this.movingMoneyDocService
        .create({
          bank_from_id: this.bank_from.id,
          bank_to_id: this.bank_to.id,
          value: this.value,
          date: this.date,
          commission: this.commission
        })
        .subscribe(
          (doc) => {
            if (!this.dialogRef) {
              this.router.navigateByUrl('/docs/moving_money/list');
            } else {
              this.dialogRef.close();
            }
            this.notificationService.notice(`Документ №${doc.id} сохранен!`);
          },
          (err) => {
            this.notificationService.warning(err.error.message);
          }
        );
    }
  }
}
